import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { DOCKED, CLASSIC } from 'conversations-internal-schema/widget-data/constants/widgetDisplayModeTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const defaultValue = {
  widgetDisplayMode: CLASSIC,
  showDisplayModeToggle: false,
  onToggleDisplayMode: () => {}
};
export const DisplayModeContext = /*#__PURE__*/createContext(defaultValue);
export const useDisplayMode = () => useContext(DisplayModeContext);
const DisplayModeProvider = ({
  isUngatedForInAppHelp,
  initialWidgetDisplayMode,
  children
}) => {
  const [userSelectedDisplayMode, setUserSelectedDisplayMode] = useState(null);
  const onToggleDisplayMode = useCallback(() => {
    if (!isUngatedForInAppHelp) return;
    setUserSelectedDisplayMode(prev => {
      if (prev === DOCKED) {
        return CLASSIC;
      }
      if (prev === CLASSIC) {
        return DOCKED;
      }
      return initialWidgetDisplayMode === DOCKED ? CLASSIC : DOCKED;
    });
  }, [isUngatedForInAppHelp, initialWidgetDisplayMode]);
  const widgetDisplayMode = useMemo(() => {
    if (!isUngatedForInAppHelp) return CLASSIC;
    if (userSelectedDisplayMode) return userSelectedDisplayMode;
    return initialWidgetDisplayMode !== null && initialWidgetDisplayMode !== void 0 ? initialWidgetDisplayMode : CLASSIC;
  }, [userSelectedDisplayMode, initialWidgetDisplayMode, isUngatedForInAppHelp]);
  const value = useMemo(() => ({
    widgetDisplayMode,
    showDisplayModeToggle: isUngatedForInAppHelp,
    onToggleDisplayMode
  }), [widgetDisplayMode, isUngatedForInAppHelp, onToggleDisplayMode]);
  return /*#__PURE__*/_jsx(DisplayModeContext.Provider, {
    value: value,
    children: children
  });
};
DisplayModeProvider.displayName = 'DisplayModeProvider';
export { DisplayModeProvider };